import { createNetworkInterface, HTTPFetchNetworkInterface, } from './transport/networkInterface';
import { createBatchingNetworkInterface, HTTPBatchedNetworkInterface, } from './transport/batchedNetworkInterface';
import { print } from 'graphql/language/printer';
import { createApolloStore, createApolloReducer } from './store';
import { ObservableQuery, } from './core/ObservableQuery';
import { readQueryFromStore } from './data/readFromStore';
import { writeQueryToStore } from './data/writeToStore';
import { getQueryDefinition, getMutationDefinition, getFragmentDefinitions, createFragmentMap, } from './queries/getFromAST';
import { NetworkStatus } from './queries/networkStatus';
import { addTypenameToDocument } from './queries/queryTransform';
import { ApolloError } from './errors/ApolloError';
import ApolloClient from './ApolloClient';
import { toIdValue } from './data/storeUtils';
import { IntrospectionFragmentMatcher, } from './data/fragmentMatcher';
export { createNetworkInterface, createBatchingNetworkInterface, createApolloStore, createApolloReducer, readQueryFromStore, writeQueryToStore, addTypenameToDocument, createFragmentMap, NetworkStatus, ApolloError, getQueryDefinition, getMutationDefinition, getFragmentDefinitions, toIdValue, IntrospectionFragmentMatcher, print as printAST, HTTPFetchNetworkInterface, HTTPBatchedNetworkInterface, ObservableQuery, ApolloClient, };
export default ApolloClient;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client/index.js
// module id = 618
// module chunks = 44